import Colors from '@/constants/Colors';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const StyledGameSpinner = styled(LoadingOutlined)`
  color: ${Colors.primary};
  font-size: 35px;
`;
